import { useRef, useState, useEffect } from "react";
import Select from "react-select";
import '../../assets/css/Modal.css';
import close from '../../assets/icons/close.svg';
import Notifier from "../../Utils/notify";
import { reactSelectStyles } from "../../Utils/selectBoxStyle";
import edit from '../../assets/icons/editnew.svg';

const OtpModal = ({
    isOpen,
    onConfirm,
    onCancel,
    onResend,
    studentResponse,
    hideOtpInput = false,
    employees = [], reverifyDiscountOtp = [], fromDiscountDashboard, skipSelectOnResend, remittances, remittancemployees = [],
    title = "Verify Discount",
    heading = "Please enter the 6-digit OTP sent to the assigned person."
}) => {

    const [isSendingOtp, setIsSendingOtp] = useState(false)
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [timer, setTimer] = useState(5);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const otpInputs = useRef([]);
    useEffect(() => {
        if (isOpen) {
            setOtp(["", "", "", "", "", ""]);
            setTimer(30);
            // setSelectedEmployees([]);
        }
        setTimeout(() => {
            otpInputs.current[0]?.focus();
        }, 0);
    }, [isOpen]);

    useEffect(() => {
        if (timer > 0) {
            const countdown = setInterval(() => setTimer((prev) => prev - 1), 1000);
            return () => clearInterval(countdown);
        }
    }, [timer]);



    const handleOtpChange = (e, index) => {
        const value = e.target.value.replace(/\D/g, "");
        if (value.length <= 1) {
            const updatedOtp = [...otp];
            updatedOtp[index] = value;
            setOtp(updatedOtp);
            if (value && index < 5) otpInputs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            otpInputs.current[index - 1]?.focus();
        }
    };

    const handleSubmitOtp = () => {
        const finalOtp = otp.join("");
        if (finalOtp.length !== 6) {
            Notifier.error("Please enter a valid 6-digit OTP.");
            return;
        }
        if (employees.length > 0 && selectedEmployees.length === 0) {
            Notifier.error("Please select at least one employee.");
            return;
        }
        // Pass OTP + selected employee IDs to the parent
        const selectedIds = selectedEmployees.map(emp => emp.value);
        onConfirm(finalOtp, selectedIds);
    };

    const handleResend = () => {
        if (timer === 0) {
            setTimer(30);
            onResend && onResend(selectedEmployees.map(emp => emp.value));
        }
        setTimeout(() => {
            otpInputs.current[0]?.focus();
        }, 0);
    };
    const [isEditingEmployee, setIsEditingEmployee] = useState(false);


    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{ position: 'relative', width: '35%', padding: '25px' }}>
                {/* Header */}
                <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h2 className='text-primary'>{title}</h2>
                    <button className="close-btn" onClick={onCancel}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* Heading */}
                <p>{heading}</p>
                {remittances && remittancemployees && (
                    <div className="p-3 border rounded shadow-sm bg-white mb-3 mt-3 d-flex justify-content-between align-items-center">
                        {!isEditingEmployee ? (
                            <>
                                <div>

                                    <p className="mb-2">
                                        <span className="fw-bold me-2">Name:</span>
                                        {studentResponse && studentResponse.employee_name
                                            ? studentResponse.employee_name
                                            : remittances?.transfered_from?.name}
                                    </p>

                                    <p className="mb-0">
                                        <span className="fw-bold me-2">Mobile:</span>
                                        {studentResponse && studentResponse.employee_mobile
                                            ? studentResponse.employee_mobile
                                            : remittances?.transfered_from?.mobile}
                                    </p>

                                </div>
                                <div>
                                    <img
                                        src={edit}
                                        style={{ cursor: "pointer" }}
                                        title="Edit employee for sent OTP"
                                        onClick={() => setIsEditingEmployee(true)}
                                        alt="edit"
                                    />
                                </div>
                            </>
                        ) : (
                            <div className="w-100 d-flex justify-content-between align-items-center gap-2">

                                <div className="flex-grow-1">
                                    <Select
                                        options={remittancemployees}
                                        value={selectedEmployees}
                                        onChange={(value) => setSelectedEmployees(value ? [value] : [])}
                                        placeholder="Select employee..."
                                        styles={reactSelectStyles}
                                    />
                                </div>
                                <div className="d-flex gap-2">
                                    <button
                                        className="add-btn"
                                        onClick={() => {
                                            setIsEditingEmployee(false);
                                            if (selectedEmployees.length > 0) {
                                                onResend && onResend(selectedEmployees.map((emp) => emp.value));
                                            }
                                        }}
                                        style={{ padding: "6px 12px" }}
                                    >
                                        Send
                                    </button>
                                    <button
                                        style={{
                                            backgroundColor: "#ccc",
                                            padding: "6px 12px",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => setIsEditingEmployee(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}


                {/* Employee Select if available */}
                {employees?.length > 0 && (
                    <div className="row mt-3" style={{ display: 'flex', alignItems: 'center', margin: '15px 0', justifyContent: 'end' }}>
                        <div className="col-md-8">
                            {/* <label style={{ fontWeight: 'bold', marginBottom: '5px', display: 'block' }}>
                                Select Employee(s)
                            </label> */}
                           
                            <Select
                                isMulti
                                options={employees.map(emp => ({
                                    value: emp.id,
                                    label: `${emp.name}`
                                }))}
                                value={selectedEmployees}
                                onChange={setSelectedEmployees}
                                placeholder="Select employee(s)..."
                                styles={reactSelectStyles}
                            />

                        </div>
                        <div className="col-md-3 text-end d-flex justify-content-end">
                            <button
                                className="add-btn"
                                style={{
                                    height: '40px',
                                    padding: '10px 13px',
                                    backgroundColor: selectedEmployees.length === 0 ? 'rgb(204, 204, 204)' : '#7F56DA', // purple when enabled
                                    cursor: selectedEmployees.length === 0 ? 'not-allowed' : 'pointer',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px'
                                }}
                                disabled={selectedEmployees.length === 0}
                                onClick={async () => {
                                    if (!onResend) return;
                                    setIsSendingOtp(true);
                                    try {
                                        await onResend(selectedEmployees.map(emp => emp.value));
                                        setSelectedEmployees([]); // reset inline
                                    } catch (error) {
                                        console.error(error);
                                    } finally {
                                        setIsSendingOtp(false);
                                    }
                                }}
                            >
                                {isSendingOtp ? <span className="spinner-border spinner-border-sm" role="status" /> : "Send"}
                            </button>
                        </div>

                    </div>
                )}


                {/* Employee Select if available AND OTP not yet created */}
                {!skipSelectOnResend && reverifyDiscountOtp?.length > 0 && studentResponse?.message !== "Fee discounts added successfully" && (
                    <div className="row mt-3" style={{ display: 'flex', alignItems: 'center', margin: '15px 0', justifyContent: 'end' }}>
                        <div className="col-md-8">
                            <Select
                                isMulti
                                options={reverifyDiscountOtp.map(emp => ({
                                    value: emp.id,
                                    label: `${emp.name}`
                                }))}
                                value={selectedEmployees}
                                onChange={setSelectedEmployees}
                                placeholder="Select employee(s)..."
                                styles={reactSelectStyles}
                            />
                        </div>
                        <div className="col-md-3 text-end d-flex justify-content-end">
                            <button
                                className="add-btn"
                                style={{
                                    height: '40px',
                                    padding: '10px 20px',
                                    backgroundColor: selectedEmployees.length === 0 ? 'rgb(204, 204, 204)' : '#7F56DA',
                                    cursor: selectedEmployees.length === 0 ? 'not-allowed' : 'pointer',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px'
                                }}
                                disabled={selectedEmployees.length === 0}
                                onClick={() => onResend && onResend(selectedEmployees.map(emp => emp.value))}
                            >
                                Send
                            </button>
                        </div>
                    </div>
                )}

                {/* OTP Inputs */}
                {!hideOtpInput && (
                    <>
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "15px", gap: '15px' }}>
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    value={digit}
                                    ref={(el) => (otpInputs.current[index] = el)}
                                    onChange={(e) => handleOtpChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    maxLength="1"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        textAlign: "center",
                                        margin: "0 5px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px"
                                    }}
                                />
                            ))}
                        </div>


                        {/* {(studentResponse?.otp || employees?.length > 0) && (
                    <p
                        style={{
                            fontWeight: 'bold',
                            color: '#555',
                            fontSize: '16px',
                            textAlign: 'center',
                            marginTop: '10px'
                        }}
                    >
                        {studentResponse?.otp
                            ? <>OTP (test): <span style={{ color: '#7F56DA' }}>{studentResponse.otp}</span></>
                            : <>Employee OTP (test): <span style={{ color: '#7F56DA' }}>{studentResponse?.otp}</span></>
                        }
                    </p>
                )}  */}

                        {/* Resend OTP */}
                        {!fromDiscountDashboard && !!employees && (
                            <div style={{ marginTop: "10px", textAlign: "center" }}>
                                {timer > 0 ? (
                                    <span style={{ color: "#888" }}>
                                        Resend OTP in {timer}s
                                    </span>
                                ) : (
                                    <button
                                        style={{
                                            background: "none",
                                            border: "none",
                                            color: "#7F56DA",
                                            cursor: "pointer",
                                            textDecoration: "underline"
                                        }}
                                        onClick={handleResend}
                                    >
                                        Resend OTP
                                    </button>
                                )}
                            </div>
                        )}


                        {/* Footer Buttons */}
                        <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <button
                                style={{
                                    backgroundColor: "#ccc",
                                    padding: "6px 15px",
                                    borderRadius: "5px",
                                    cursor: "pointer"
                                }}

                                onClick={onCancel}
                            >
                                Cancel
                            </button>
                            <button 
                                className="add-btn"
                                style={{
                                    cursor: otp.join("").length !== 6 ? 'not-allowed' : 'pointer',
                                    backgroundColor: otp.join("").length !== 6 ? '#d3d3d3' : '#7F56DA',
                                }}
                                disabled={otp.join("").length !== 6}
                                onClick={handleSubmitOtp}
                            >
                                Verify OTP
                            </button>
                        </div>

                    </>
                )}
            </div>
        </div>
    );
};

export default OtpModal;

